module.exports = __webpack_public_path__ + "static/media/GroundingTechniquesENG.253ee28c.vtt";